export default "__VITE_ASSET__C9BZ2wg4__"